import axiosInstance from "../utils/axios";

export const ministryVocationalInstitutionService = {
  fetchAll: async (params = {}) => {
    const response = await axiosInstance.get(
      "/ministry-vocational-institution",
      { params },
    );
    return response.data;
  },

  fetchEligibleInstitutions: async (params = {}) => {
    const response = await axiosInstance.get(
      "/ministry-vocational-institution/eligible-institutions",
      {
        params,
      },
    );
    return response.data;
  },

  findById: async (id) => {
    const response = await axiosInstance.get(
      `/ministry-vocational-institution/${id}`,
    );
    return response.data;
  },

  store: async (data) => {
    const response = await axiosInstance.post(
      "/ministry-vocational-institution",
      data,
    );
    return response.data;
  },

  update: async (id, data) => {
    const response = await axiosInstance.put(
      `/ministry-vocational-institution/${id}`,
      data,
    );
    return response.data;
  },

  delete: async (id) => {
    const response = await axiosInstance.delete(
      `/ministry-vocational-institution/${id}`,
    );
    return response.data;
  },

  exportExcel: async (params = {}) => {
    const response = await axiosInstance.get(
      "/ministry-vocational-institution/export-excel",
      {
        params,
        responseType: "blob",
      },
    );
    return response;
  },
};

export default ministryVocationalInstitutionService;
